import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/404/index.tsx");
